<template>
  <el-select
    :model-value="modelValue"
    class="w-full"
    filterable
    @update:model-value="$emit('update:modelValue', $event)">
    <el-option
      v-for="country in countryList"
      :key="country.codeIso2"
      :label="country.label"
      :value="country.codeIso2" />
  </el-select>
</template>

<script>

const COUNTRY_LIST = [
  { label: "Afghanistan (l')", codeIso3: 'AFG', codeIso2: 'AF' },
  { label: "Albanie (l')", codeIso3: 'ALB', codeIso2: 'AL' },
  { label: "Algérie (l')", codeIso3: 'DZA', codeIso2: 'DZ' },
  { label: 'Samoa américaines (les)', codeIso3: 'ASM', codeIso2: 'AS' },
  { label: "Andorre (l')", codeIso3: 'AND', codeIso2: 'AD' },
  { label: "Angola (l')", codeIso3: 'AGO', codeIso2: 'AO' },
  { label: 'Anguilla', codeIso3: 'AIA', codeIso2: 'AI' },
  { label: "Antarctique (l')", codeIso3: 'ATA', codeIso2: 'AQ' },
  { label: 'Antigua-et-Barbuda', codeIso3: 'ATG', codeIso2: 'AG' },
  { label: "Argentine (l')", codeIso3: 'ARG', codeIso2: 'AR' },
  { label: "Arménie (l')", codeIso3: 'ARM', codeIso2: 'AM' },
  { label: 'Aruba', codeIso3: 'ABW', codeIso2: 'AW' },
  { label: "Australie (l')", codeIso3: 'AUS', codeIso2: 'AU' },
  { label: "Autriche (l')", codeIso3: 'AUT', codeIso2: 'AT' },
  { label: "Azerbaïdjan (l')", codeIso3: 'AZE', codeIso2: 'AZ' },
  { label: 'Bahamas (les)', codeIso3: 'BHS', codeIso2: 'BS' },
  { label: 'Bahreïn', codeIso3: 'BHR', codeIso2: 'BH' },
  { label: 'Bangladesh (le)', codeIso3: 'BGD', codeIso2: 'BD' },
  { label: 'Barbade (la)', codeIso3: 'BRB', codeIso2: 'BB' },
  { label: 'Bélarus (le)', codeIso3: 'BLR', codeIso2: 'BY' },
  { label: 'Belgique (la)', codeIso3: 'BEL', codeIso2: 'BE' },
  { label: 'Belize (le)', codeIso3: 'BLZ', codeIso2: 'BZ' },
  { label: 'Bénin (le)', codeIso3: 'BEN', codeIso2: 'BJ' },
  { label: 'Bermudes (les)', codeIso3: 'BMU', codeIso2: 'BM' },
  { label: 'Bhoutan (le)', codeIso3: 'BTN', codeIso2: 'BT' },
  { label: 'Bolivie (État plurinational de)', codeIso3: 'BOL', codeIso2: 'BO' },
  { label: 'Bonaire, Saint-Eustache et Saba', codeIso3: 'BES', codeIso2: 'BQ' },
  { label: 'Bosnie-Herzégovine (la)', codeIso3: 'BIH', codeIso2: 'BA' },
  { label: 'Botswana (le)', codeIso3: 'BWA', codeIso2: 'BW' },
  { label: "Bouvet (l'Île)", codeIso3: 'BVT', codeIso2: 'BV' },
  { label: 'Brésil (le)', codeIso3: 'BRA', codeIso2: 'BR' },
  { label: "Indien (le Territoire britannique de l'océan)", codeIso3: 'IOT', codeIso2: 'IO' },
  { label: 'Brunéi Darussalam (le)', codeIso3: 'BRN', codeIso2: 'BN' },
  { label: 'Bulgarie (la)', codeIso3: 'BGR', codeIso2: 'BG' },
  { label: 'Burkina Faso (le)', codeIso3: 'BFA', codeIso2: 'BF' },
  { label: 'Burundi (le)', codeIso3: 'BDI', codeIso2: 'BI' },
  { label: 'Cabo Verde', codeIso3: 'CPV', codeIso2: 'CV' },
  { label: 'Cambodge (le)', codeIso3: 'KHM', codeIso2: 'KH' },
  { label: 'Cameroun (le)', codeIso3: 'CMR', codeIso2: 'CM' },
  { label: 'Canada (le)', codeIso3: 'CAN', codeIso2: 'CA' },
  { label: 'Caïmans (les Îles)', codeIso3: 'CYM', codeIso2: 'KY' },
  { label: 'République centrafricaine (la)', codeIso3: 'CAF', codeIso2: 'CF' },
  { label: 'Tchad (le)', codeIso3: 'TCD', codeIso2: 'TD' },
  { label: 'Chili (le)', codeIso3: 'CHL', codeIso2: 'CL' },
  { label: 'Chine (la)', codeIso3: 'CHN', codeIso2: 'CN' },
  { label: "Christmas (l'Île)", codeIso3: 'CXR', codeIso2: 'CX' },
  { label: 'Cocos (les Îles)/ Keeling (les Îles)', codeIso3: 'CCK', codeIso2: 'CC' },
  { label: 'Colombie (la)', codeIso3: 'COL', codeIso2: 'CO' },
  { label: 'Comores (les)', codeIso3: 'COM', codeIso2: 'KM' },
  { label: 'Congo (la République démocratique du)', codeIso3: 'COD', codeIso2: 'CD' },
  { label: 'Congo (le)', codeIso3: 'COG', codeIso2: 'CG' },
  { label: 'Cook (les Îles)', codeIso3: 'COK', codeIso2: 'CK' },
  { label: 'Costa Rica (le)', codeIso3: 'CRI', codeIso2: 'CR' },
  { label: 'Croatie (la)', codeIso3: 'HRV', codeIso2: 'HR' },
  { label: 'Cuba', codeIso3: 'CUB', codeIso2: 'CU' },
  { label: 'Curaçao', codeIso3: 'CUW', codeIso2: 'CW' },
  { label: 'Chypre', codeIso3: 'CYP', codeIso2: 'CY' },
  { label: 'Tchéquie (la)', codeIso3: 'CZE', codeIso2: 'CZ' },
  { label: "Côte d'Ivoire (la)", codeIso3: 'CIV', codeIso2: 'CI' },
  { label: 'Danemark (le)', codeIso3: 'DNK', codeIso2: 'DK' },
  { label: 'Djibouti', codeIso3: 'DJI', codeIso2: 'DJ' },
  { label: 'Dominique (la)', codeIso3: 'DMA', codeIso2: 'DM' },
  { label: 'dominicaine (la République)', codeIso3: 'DOM', codeIso2: 'DO' },
  { label: "Équateur (l')", codeIso3: 'ECU', codeIso2: 'EC' },
  { label: "Égypte (l')", codeIso3: 'EGY', codeIso2: 'EG' },
  { label: 'El Salvador', codeIso3: 'SLV', codeIso2: 'SV' },
  { label: 'Guinée équatoriale (la)', codeIso3: 'GNQ', codeIso2: 'GQ' },
  { label: "Érythrée (l')", codeIso3: 'ERI', codeIso2: 'ER' },
  { label: "Estonie (l')", codeIso3: 'EST', codeIso2: 'EE' },
  { label: "Eswatini (l')", codeIso3: 'SWZ', codeIso2: 'SZ' },
  { label: "Éthiopie (l')", codeIso3: 'ETH', codeIso2: 'ET' },
  { label: 'Falkland (les Îles)/Malouines (les Îles)', codeIso3: 'FLK', codeIso2: 'FK' },
  { label: 'Féroé (les Îles)', codeIso3: 'FRO', codeIso2: 'FO' },
  { label: 'Fidji (les)', codeIso3: 'FJI', codeIso2: 'FJ' },
  { label: 'Finlande (la)', codeIso3: 'FIN', codeIso2: 'FI' },
  { label: 'France (la)', codeIso3: 'FRA', codeIso2: 'FR' },
  { label: 'Guyane française (la )', codeIso3: 'GUF', codeIso2: 'GF' },
  { label: 'Polynésie française (la)', codeIso3: 'PYF', codeIso2: 'PF' },
  { label: 'Terres australes françaises (les)', codeIso3: 'ATF', codeIso2: 'TF' },
  { label: 'Gabon (le)', codeIso3: 'GAB', codeIso2: 'GA' },
  { label: 'Gambie (la)', codeIso3: 'GMB', codeIso2: 'GM' },
  { label: 'Géorgie (la)', codeIso3: 'GEO', codeIso2: 'GE' },
  { label: "Allemagne (l')", codeIso3: 'DEU', codeIso2: 'DE' },
  { label: 'Ghana (le)', codeIso3: 'GHA', codeIso2: 'GH' },
  { label: 'Gibraltar', codeIso3: 'GIB', codeIso2: 'GI' },
  { label: 'Grèce (la)', codeIso3: 'GRC', codeIso2: 'GR' },
  { label: 'Groenland (le)', codeIso3: 'GRL', codeIso2: 'GL' },
  { label: 'Grenade (la)', codeIso3: 'GRD', codeIso2: 'GD' },
  { label: 'Guadeloupe (la)', codeIso3: 'GLP', codeIso2: 'GP' },
  { label: 'Guam', codeIso3: 'GUM', codeIso2: 'GU' },
  { label: 'Guatemala (le)', codeIso3: 'GTM', codeIso2: 'GT' },
  { label: 'Guernesey', codeIso3: 'GGY', codeIso2: 'GG' },
  { label: 'Guinée (la)', codeIso3: 'GIN', codeIso2: 'GN' },
  { label: 'Guinée-Bissau (la)', codeIso3: 'GNB', codeIso2: 'GW' },
  { label: 'Guyana (le)', codeIso3: 'GUY', codeIso2: 'GY' },
  { label: 'Haïti', codeIso3: 'HTI', codeIso2: 'HT' },
  { label: "Heard-et-Îles MacDonald (l'Île)", codeIso3: 'HMD', codeIso2: 'HM' },
  { label: 'Saint-Siège (le)', codeIso3: 'VAT', codeIso2: 'VA' },
  { label: 'Honduras (le)', codeIso3: 'HND', codeIso2: 'HN' },
  { label: 'Hong Kong', codeIso3: 'HKG', codeIso2: 'HK' },
  { label: 'Hongrie (la)', codeIso3: 'HUN', codeIso2: 'HU' },
  { label: "Islande (l')", codeIso3: 'ISL', codeIso2: 'IS' },
  { label: "Inde (l')", codeIso3: 'IND', codeIso2: 'IN' },
  { label: "Indonésie (l')", codeIso3: 'IDN', codeIso2: 'ID' },
  { label: "Iran (République Islamique d')", codeIso3: 'IRN', codeIso2: 'IR' },
  { label: "Iraq (l')", codeIso3: 'IRQ', codeIso2: 'IQ' },
  { label: "Irlande (l')", codeIso3: 'IRL', codeIso2: 'IE' },
  { label: 'Île de Man', codeIso3: 'IMN', codeIso2: 'IM' },
  { label: 'Israël', codeIso3: 'ISR', codeIso2: 'IL' },
  { label: "Italie (l')", codeIso3: 'ITA', codeIso2: 'IT' },
  { label: 'Jamaïque (la)', codeIso3: 'JAM', codeIso2: 'JM' },
  { label: 'Japon (le)', codeIso3: 'JPN', codeIso2: 'JP' },
  { label: 'Jersey', codeIso3: 'JEY', codeIso2: 'JE' },
  { label: 'Jordanie (la)', codeIso3: 'JOR', codeIso2: 'JO' },
  { label: 'Kazakhstan (le)', codeIso3: 'KAZ', codeIso2: 'KZ' },
  { label: 'Kenya (le)', codeIso3: 'KEN', codeIso2: 'KE' },
  { label: 'Kiribati', codeIso3: 'KIR', codeIso2: 'KI' },
  { label: 'Corée (la République populaire démocratique de)', codeIso3: 'PRK', codeIso2: 'KP' },
  { label: 'Corée (la République de)', codeIso3: 'KOR', codeIso2: 'KR' },
  { label: 'Koweït (le)', codeIso3: 'KWT', codeIso2: 'KW' },
  { label: 'Kirghizistan (le)', codeIso3: 'KGZ', codeIso2: 'KG' },
  { label: 'Lao (la République démocratique populaire)', codeIso3: 'LAO', codeIso2: 'LA' },
  { label: 'Lettonie (la)', codeIso3: 'LVA', codeIso2: 'LV' },
  { label: 'Liban (le)', codeIso3: 'LBN', codeIso2: 'LB' },
  { label: 'Lesotho (le)', codeIso3: 'LSO', codeIso2: 'LS' },
  { label: 'Libéria (le)', codeIso3: 'LBR', codeIso2: 'LR' },
  { label: 'Libye (la)', codeIso3: 'LBY', codeIso2: 'LY' },
  { label: 'Liechtenstein (le)', codeIso3: 'LIE', codeIso2: 'LI' },
  { label: 'Lituanie (la)', codeIso3: 'LTU', codeIso2: 'LT' },
  { label: 'Luxembourg (le)', codeIso3: 'LUX', codeIso2: 'LU' },
  { label: 'Macao', codeIso3: 'MAC', codeIso2: 'MO' },
  { label: 'Madagascar', codeIso3: 'MDG', codeIso2: 'MG' },
  { label: 'Malawi (le)', codeIso3: 'MWI', codeIso2: 'MW' },
  { label: 'Malaisie (la)', codeIso3: 'MYS', codeIso2: 'MY' },
  { label: 'Maldives (les)', codeIso3: 'MDV', codeIso2: 'MV' },
  { label: 'Mali (le)', codeIso3: 'MLI', codeIso2: 'ML' },
  { label: 'Malte', codeIso3: 'MLT', codeIso2: 'MT' },
  { label: 'Marshall (les Îles)', codeIso3: 'MHL', codeIso2: 'MH' },
  { label: 'Martinique (la)', codeIso3: 'MTQ', codeIso2: 'MQ' },
  { label: 'Mauritanie (la)', codeIso3: 'MRT', codeIso2: 'MR' },
  { label: 'Maurice', codeIso3: 'MUS', codeIso2: 'MU' },
  { label: 'Mayotte', codeIso3: 'MYT', codeIso2: 'YT' },
  { label: 'Mexique (le)', codeIso3: 'MEX', codeIso2: 'MX' },
  { label: 'Micronésie (États fédérés de)', codeIso3: 'FSM', codeIso2: 'FM' },
  { label: 'Moldova (la République de)', codeIso3: 'MDA', codeIso2: 'MD' },
  { label: 'Monaco', codeIso3: 'MCO', codeIso2: 'MC' },
  { label: 'Mongolie (la)', codeIso3: 'MNG', codeIso2: 'MN' },
  { label: 'Monténégro (le)', codeIso3: 'MNE', codeIso2: 'ME' },
  { label: 'Montserrat', codeIso3: 'MSR', codeIso2: 'MS' },
  { label: 'Maroc (le)', codeIso3: 'MAR', codeIso2: 'MA' },
  { label: 'Mozambique (le)', codeIso3: 'MOZ', codeIso2: 'MZ' },
  { label: 'Myanmar (le)', codeIso3: 'MMR', codeIso2: 'MM' },
  { label: 'Namibie (la)', codeIso3: 'NAM', codeIso2: 'NA' },
  { label: 'Nauru', codeIso3: 'NRU', codeIso2: 'NR' },
  { label: 'Népal (le)', codeIso3: 'NPL', codeIso2: 'NP' },
  { label: 'Pays-Bas (les)', codeIso3: 'NLD', codeIso2: 'NL' },
  { label: 'Nouvelle-Calédonie (la)', codeIso3: 'NCL', codeIso2: 'NC' },
  { label: 'Nouvelle-Zélande (la)', codeIso3: 'NZL', codeIso2: 'NZ' },
  { label: 'Nicaragua (le)', codeIso3: 'NIC', codeIso2: 'NI' },
  { label: 'Niger (le)', codeIso3: 'NER', codeIso2: 'NE' },
  { label: 'Nigéria (le)', codeIso3: 'NGA', codeIso2: 'NG' },
  { label: 'Niue', codeIso3: 'NIU', codeIso2: 'NU' },
  { label: "Norfolk (l'Île)", codeIso3: 'NFK', codeIso2: 'NF' },
  { label: 'Macédoine du Nord (la)', codeIso3: 'MKD', codeIso2: 'MK' },
  { label: 'Mariannes du Nord (les Îles)', codeIso3: 'MNP', codeIso2: 'MP' },
  { label: 'Norvège (la)', codeIso3: 'NOR', codeIso2: 'NO' },
  { label: 'Oman', codeIso3: 'OMN', codeIso2: 'OM' },
  { label: 'Pakistan (le)', codeIso3: 'PAK', codeIso2: 'PK' },
  { label: 'Palaos (les)', codeIso3: 'PLW', codeIso2: 'PW' },
  { label: 'Palestine, État de', codeIso3: 'PSE', codeIso2: 'PS' },
  { label: 'Panama (le)', codeIso3: 'PAN', codeIso2: 'PA' },
  { label: 'Papouasie-Nouvelle-Guinée (la)', codeIso3: 'PNG', codeIso2: 'PG' },
  { label: 'Paraguay (le)', codeIso3: 'PRY', codeIso2: 'PY' },
  { label: 'Pérou (le)', codeIso3: 'PER', codeIso2: 'PE' },
  { label: 'Philippines (les)', codeIso3: 'PHL', codeIso2: 'PH' },
  { label: 'Pitcairn', codeIso3: 'PCN', codeIso2: 'PN' },
  { label: 'Pologne (la)', codeIso3: 'POL', codeIso2: 'PL' },
  { label: 'Portugal (le)', codeIso3: 'PRT', codeIso2: 'PT' },
  { label: 'Porto Rico', codeIso3: 'PRI', codeIso2: 'PR' },
  { label: 'Qatar (le)', codeIso3: 'QAT', codeIso2: 'QA' },
  { label: 'Roumanie (la)', codeIso3: 'ROU', codeIso2: 'RO' },
  { label: 'Russie (la Fédération de)', codeIso3: 'RUS', codeIso2: 'RU' },
  { label: 'Rwanda (le)', codeIso3: 'RWA', codeIso2: 'RW' },
  { label: 'Réunion (La)', codeIso3: 'REU', codeIso2: 'RE' },
  { label: 'Saint-Barthélemy', codeIso3: 'BLM', codeIso2: 'BL' },
  { label: 'Sainte-Hélène, Ascension et Tristan da Cunha', codeIso3: 'SHN', codeIso2: 'SH' },
  { label: 'Saint-Kitts-et-Nevis', codeIso3: 'KNA', codeIso2: 'KN' },
  { label: 'Sainte-Lucie', codeIso3: 'LCA', codeIso2: 'LC' },
  { label: 'Saint-Martin (partie française)', codeIso3: 'MAF', codeIso2: 'MF' },
  { label: 'Saint-Pierre-et-Miquelon', codeIso3: 'SPM', codeIso2: 'PM' },
  { label: 'Saint-Vincent-et-les Grenadines', codeIso3: 'VCT', codeIso2: 'VC' },
  { label: 'Samoa (le)', codeIso3: 'WSM', codeIso2: 'WS' },
  { label: 'Saint-Marin', codeIso3: 'SMR', codeIso2: 'SM' },
  { label: 'Sao Tomé-et-Principe', codeIso3: 'STP', codeIso2: 'ST' },
  { label: "Arabie saoudite (l')", codeIso3: 'SAU', codeIso2: 'SA' },
  { label: 'Sénégal (le)', codeIso3: 'SEN', codeIso2: 'SN' },
  { label: 'Serbie (la)', codeIso3: 'SRB', codeIso2: 'RS' },
  { label: 'Seychelles (les)', codeIso3: 'SYC', codeIso2: 'SC' },
  { label: 'Sierra Leone (la)', codeIso3: 'SLE', codeIso2: 'SL' },
  { label: 'Singapour', codeIso3: 'SGP', codeIso2: 'SG' },
  { label: 'Saint-Martin (partie néerlandaise)', codeIso3: 'SXM', codeIso2: 'SX' },
  { label: 'Slovaquie (la)', codeIso3: 'SVK', codeIso2: 'SK' },
  { label: 'Slovénie (la)', codeIso3: 'SVN', codeIso2: 'SI' },
  { label: 'Salomon (les Îles)', codeIso3: 'SLB', codeIso2: 'SB' },
  { label: 'Somalie (la)', codeIso3: 'SOM', codeIso2: 'SO' },
  { label: "Afrique du Sud (l')", codeIso3: 'ZAF', codeIso2: 'ZA' },
  { label: 'Géorgie du Sud-et-les Îles Sandwich du Sud (la)', codeIso3: 'SGS', codeIso2: 'GS' },
  { label: 'Soudan du Sud (le)', codeIso3: 'SSD', codeIso2: 'SS' },
  { label: "Espagne (l')", codeIso3: 'ESP', codeIso2: 'ES' },
  { label: 'Sri Lanka', codeIso3: 'LKA', codeIso2: 'LK' },
  { label: 'Soudan (le)', codeIso3: 'SDN', codeIso2: 'SD' },
  { label: 'Suriname (le)', codeIso3: 'SUR', codeIso2: 'SR' },
  { label: "Svalbard et l'Île Jan Mayen (le)", codeIso3: 'SJM', codeIso2: 'SJ' },
  { label: 'Suède (la)', codeIso3: 'SWE', codeIso2: 'SE' },
  { label: 'Suisse (la)', codeIso3: 'CHE', codeIso2: 'CH' },
  { label: 'République arabe syrienne (la)', codeIso3: 'SYR', codeIso2: 'SY' },
  { label: 'Taïwan (Province de Chine)', codeIso3: 'TWN', codeIso2: 'TW' },
  { label: 'Tadjikistan (le)', codeIso3: 'TJK', codeIso2: 'TJ' },
  { label: 'Tanzanie (la République-Unie de)', codeIso3: 'TZA', codeIso2: 'TZ' },
  { label: 'Thaïlande (la)', codeIso3: 'THA', codeIso2: 'TH' },
  { label: 'Timor-Leste (le)', codeIso3: 'TLS', codeIso2: 'TL' },
  { label: 'Togo (le)', codeIso3: 'TGO', codeIso2: 'TG' },
  { label: 'Tokelau (les)', codeIso3: 'TKL', codeIso2: 'TK' },
  { label: 'Tonga (les)', codeIso3: 'TON', codeIso2: 'TO' },
  { label: 'Trinité-et-Tobago (la)', codeIso3: 'TTO', codeIso2: 'TT' },
  { label: 'Tunisie (la)', codeIso3: 'TUN', codeIso2: 'TN' },
  { label: 'Turquie (la)', codeIso3: 'TUR', codeIso2: 'TR' },
  { label: 'Turkménistan (le)', codeIso3: 'TKM', codeIso2: 'TM' },
  { label: 'Turks-et-Caïcos (les Îles)', codeIso3: 'TCA', codeIso2: 'TC' },
  { label: 'Tuvalu (les)', codeIso3: 'TUV', codeIso2: 'TV' },
  { label: "Ouganda (l')", codeIso3: 'UGA', codeIso2: 'UG' },
  { label: "Ukraine (l')", codeIso3: 'UKR', codeIso2: 'UA' },
  { label: 'Émirats arabes unis (les)', codeIso3: 'ARE', codeIso2: 'AE' },
  { label: "Royaume-Uni de Grande-Bretagne et d'Irlande du Nord (le)", codeIso3: 'GBR', codeIso2: 'GB' },
  { label: 'Îles mineures éloignées des États-Unis (les)', codeIso3: 'UMI', codeIso2: 'UM' },
  { label: "États-Unis d'Amérique (les)", codeIso3: 'USA', codeIso2: 'US' },
  { label: "Uruguay (l')", codeIso3: 'URY', codeIso2: 'UY' },
  { label: "Ouzbékistan (l')", codeIso3: 'UZB', codeIso2: 'UZ' },
  { label: 'Vanuatu (le)', codeIso3: 'VUT', codeIso2: 'VU' },
  { label: 'Venezuela (République bolivarienne du)', codeIso3: 'VEN', codeIso2: 'VE' },
  { label: 'Viet Nam (le)', codeIso3: 'VNM', codeIso2: 'VN' },
  { label: 'Vierges britanniques (les Îles)', codeIso3: 'VGB', codeIso2: 'VG' },
  { label: 'Vierges des États-Unis (les Îles)', codeIso3: 'VIR', codeIso2: 'VI' },
  { label: 'Wallis-et-Futuna', codeIso3: 'WLF', codeIso2: 'WF' },
  { label: 'Sahara occidental (le)*', codeIso3: 'ESH', codeIso2: 'EH' },
  { label: 'Yémen (le)', codeIso3: 'YEM', codeIso2: 'YE' },
  { label: 'Zambie (la)', codeIso3: 'ZMB', codeIso2: 'ZM' },
  { label: 'Zimbabwe (le)', codeIso3: 'ZWE', codeIso2: 'ZW' },
  { label: 'Åland(les Îles)', codeIso3: 'ALA', codeIso2: 'AX' }
];

export default {
  name: 'countrySelector',
  props: {
    modelValue: { type: String, default: '' }
  },
  emits: ['update:modelValue'],
  data () {
    return { countryList: COUNTRY_LIST };
  }
};
</script>
